export default __webpack_public_path__ + "static/nara_logo_720-6dea9785fc45b9b713bb39cb1f71a8f5.webp";